window.PRODUCT_DATA = [
  {
    "product": "Her Santulan",
    "variant_id": "46466095906994",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_her_santulan.webp?v=1774597567",
    "ingredients": [
      { "name": "Shatavari", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027", "content": "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair." },
      { "name": "Brahmi", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027", "content": "Calms scalp stress response, supporting healthier follicle activity and reduced hair fall." }
    ],
    "effect": "Her Santulan supports daily wellness to maintain healthy hair."
  },
  {
    "product": "Mom Santulan for Postpartum hair",
    "variant_id": "46466402779314",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_mom_santulan.webp?v=1774597568",
    "ingredients": [
      { "name": "Vidarikand", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vidarikand.webp?v=1770375187", "content": "Nourishes hair roots by supporting hormonal balance and tissue strength." },
      { "name": "Lodhra", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Lodhra.webp?v=1770375186", "content": "Helps balance scalp oiliness and supports a healthier follicle environment." }
    ],
    "effect": "Mom Santulan helps reduce post-partum hair fall."
  },
  {
    "product": "Iron Santulan",
    "variant_id": "46465792704690",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_iron_santulan.webp?v=1774597567",
    "ingredients": [
      { "name": "Navayasa Loh", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Navayasa.webp?v=1770375340", "content": "Helps correct iron-related deficiencies that contribute to excessive hair fall." },
      { "name": "Pippali", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365", "content": "Improves metabolism and circulation, helping nutrients reach hair follicles efficiently." }
    ],
    "effect": "Iron Santulan helps reduce hair fall caused by anemia."
  },
  {
    "product": "PCOS Santulan",
    "variant_id": "42739969032370",
    "internal": true,
    "external": false,
    "dosage": { "morning": null, "night": null, "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_PCOS_santulan.webp?v=1774597568",
    "ingredients": [],
    "effect": "PCOS Santulan helps to reduce hair fall caused by PCOS."
  },
  {
    "product": "Thyro Santulan",
    "variant_id": "46466225438898",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_thyro_santulan.webp?v=1774597568",
    "ingredients": [
      { "name": "Chandraprabha Vati", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Chandraprabhavati.png?v=1770375642", "content": "Supports hormonal balance and metabolic health, helping reduce internally triggered hair fall." },
      { "name": "Triphala", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Triphala.png?v=1758868752", "content": "Supports detox and nutrient absorption for healthier hair growth." }
    ],
    "effect": "Thyro Santulan helps reduce hair fall caused by thyroid issues."
  },
  {
    "product": "Gut Shuddhi",
    "variant_id": "46528902496434",
    "internal": true,
    "external": false,
    "dosage": { "morning": null, "night": "1 Tablet", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_gut_shuddhi.webp?v=1774597568",
    "ingredients": [
      { "name": "Amla", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Rich in antioxidants, strengthens hair roots and supports hair growth." },
      { "name": "Sunth", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802", "content": "Enhances blood flow and nutrient delivery to support healthy hair growth." }
    ],
    "effect": "Gut Shuddhi supports digestion to help reduce hair fall."
  },
  {
    "product": "Digest Boost",
    "variant_id": "46528963936434",
    "internal": true,
    "external": false,
    "dosage": { "morning": "1 Tablet", "night": "1 Tablet", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_digest_boost.webp?v=1774597567",
    "ingredients": [
      { "name": "Variyali", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Variyali.webp?v=1770376077", "content": "Improves digestion and reduces internal heat, supporting healthier hair growth from within." },
      { "name": "Ganthoda", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ganthoda.webp?v=1770376091", "content": "Boosts circulation and digestion, supporting nourishment to hair follicles." }
    ],
    "effect": "Digest Boost supports digestion to help reduce hair fall."
  },
  {
    "product": "Health Tatva",
    "variant_id": "46528920289458",
    "internal": true,
    "external": false,
    "dosage": { "morning": "1 Tablet", "night": "1 Tablet", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_health_tatva.webp?v=1774597568",
    "ingredients": [
      { "name": "Sunth", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Sunth.webp?v=1770375802", "content": "Improves blood circulation and digestion, helping nutrients reach hair follicles effectively." },
      { "name": "Pippali", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pippali.png?v=1770375365", "content": "Improves metabolism and circulation, helping nutrients reach hair follicles efficiently." }
    ],
    "effect": "Health Tatva helps in boosting metabolism."
  },
  {
    "product": "Hair Vitamin for her",
    "variant_id": "47303097352370",
    "internal": true,
    "external": false,
    "dosage": { "morning": "1 Tablet", "night": null, "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_vitamin_her.webp?v=1774597567",
    "ingredients": [
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping strengthen hair and reduce breakage." },
      { "name": "Amino Acids", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Amino_Acids.webp?v=1770376900", "content": "Build keratin structure, improving hair strength, thickness, and resistance to breakage." }
    ],
    "effect": "Hair Vitamin addresses nutritional deficiency to reduce hair fall."
  },
  {
    "product": "Hair Vitamin",
    "variant_id": "47303072710834",
    "internal": true,
    "external": false,
    "dosage": { "morning": "1 Tablet", "night": null, "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_vitamin.webp?v=1774597568",
    "ingredients": [
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping strengthen hair and reduce breakage." },
      { "name": "Pumpkin Seed Extract", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Pumpkin_Seed_Extract.png?v=1758868752", "content": "Helps block DHT activity, supporting reduced hair thinning." }
    ],
    "effect": "Hair Vitamin addresses nutritional deficiency to reduce hair fall."
  },
  {
    "product": "Calm Ras",
    "variant_id": "47276517195954",
    "internal": true,
    "external": false,
    "dosage": { "morning": null, "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_calm_ras.webp?v=1774597567",
    "ingredients": [
      { "name": "Ashwagandha", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173", "content": "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth." },
      { "name": "Brahmi", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027", "content": "Prolongs hair growth phase and strengthens roots, supporting thicker and healthier hair regrowth." }
    ],
    "effect": "Calm Ras helps to reduce hair fall caused by stress."
  },
  {
    "product": "Nasal Ghrit",
    "variant_id": "46466175008946",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": "2-3 DROPS", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_nasal_ghrit.webp?v=1774597568",
    "ingredients": [
      { "name": "Cow Ghee", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Cow_Ghee_1.png?v=1758868752", "content": "Deeply moisturizes scalp and supports repair of dry, brittle hair shafts." },
      { "name": "Shatavari", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027", "content": "Supports hormonal balance and nourishment of hair follicles in women." }
    ],
    "effect": "Nasal Ghrit promotes better sleep to help reduce hair fall."
  },
  {
    "product": "Hair Ras",
    "variant_id": "46528906821810",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras.webp?v=1774597567",
    "ingredients": [
      { "name": "Ashwagandha", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173", "content": "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth." },
      { "name": "Bringhraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj.webp?v=1770379802", "content": "Reduces stress hormones and improves scalp nourishment, helping control stress-related hair fall." }
    ],
    "effect": "Hair Ras provides essential nourishment for stronger, healthier hair."
  },
  {
    "product": "Anti-Dandruff Shampoo",
    "variant_id": "47329496826034",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "During wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_ketoconazole_shampoo.webp?v=1774597567",
    "ingredients": [
      { "name": "Ketoconazole 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073", "content": "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss." },
      { "name": "Aloe Vera", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912", "content": "Helps reduce scalp dryness and flaking that can weaken hair roots." }
    ],
    "effect": "Anti-Dandruff Shampoo fights dandruff to help reduce hair fall."
  },
  {
    "product": "Recap Serum",
    "variant_id": "41645770309810",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_recap_hair_serum.webp?v=1774597568",
    "ingredients": [],
    "effect": "Recap Serum supports hair regrowth for fuller, healthier hair."
  },
  {
    "product": "Anti Dandruff Solution",
    "variant_id": "46528923304114",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply overnight before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_2__ketoconazole.webp?v=1774597567",
    "ingredients": [
      { "name": "Ketoconazole 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Anti-dandruff_keto.webp?v=1770380073", "content": "Reduces dandruff-causing fungus and scalp inflammation linked to hair loss." },
      { "name": "Aloe Vera", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/aloe_vera.webp?v=1770296912", "content": "Soothes irritated scalp and supports moisture balance for healthier hair growth." }
    ],
    "effect": "Night Lotion fights dandruff to help reduce hair fall."
  },
  {
    "product": "Scalp Oil 100ml with Dandruff Oil Shot",
    "variant_id": "46530320040114",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply 30 mins before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_scalp_oil_100ml_dandruff_oil_shot.webp?v=1774597568",
    "ingredients": [
      { "name": "Camphor", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600", "content": "Improves scalp circulation and helps relieve itchiness linked to hair fall." },
      { "name": "Castor Oil", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/CastorOil.webp?v=1770297142", "content": "Nourishes scalp and supports thicker-looking hair by strengthening strands." }
    ],
    "effect": "Scalp Oil nurtures scalp health to support stronger hair."
  },
  {
    "product": "Scalp Oil 100ml with Scalp Health Oil Shot",
    "variant_id": "46531529638066",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply 30 mins before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_scalp_oil_100ml_scalp_health_oil_shot.webp?v=1774597567",
    "ingredients": [
      { "name": "Bergamot", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bergamot.webp?v=1770380916", "content": "Helps balance oily scalp and supports a healthier scalp environment." },
      { "name": "ORPL", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ORPL.webp?v=1770380916", "content": "Helps improve hair fibre strength and reduces breakage from daily stress." }
    ],
    "effect": "Scalp Oil nurtures scalp health to support stronger hair."
  },
  {
    "product": "Scalp Oil 100ml with Calm Oil Shot",
    "variant_id": "46530283012274",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply 30 mins before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_scalp_oil_100ml_calm_oil_shot.webp?v=1774597567",
    "ingredients": [
      { "name": "Coconut Oil", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_13.webp?v=1770381512", "content": "Penetrates hair shaft to reduce protein loss and strengthen strands." },
      { "name": "Amla", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Rich in antioxidants, strengthens hair roots and supports hair density." }
    ],
    "effect": "Scalp Oil nurtures scalp health to support stronger hair."
  },
  {
    "product": "Scalp Oil 100ml with Growth Oil Shot",
    "variant_id": "46530384527538",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply 30 mins before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_scalp_oil_100ml_growth_oil_shot.webp?v=1774597567",
    "ingredients": [
      { "name": "Camphor", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Camphor.webp?v=1770380600", "content": "Improves scalp circulation and helps relieve itchiness linked to hair fall." },
      { "name": "Wheat Germ", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_14.webp?v=1770381631", "content": "Rich in vitamin E, supports scalp nourishment and hair strength." }
    ],
    "effect": "Scalp Oil nurtures scalp health to support stronger hair."
  },
  {
    "product": "Nourish Hair Oil",
    "variant_id": "47302951403698",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Apply 30 mins before wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_nourish_hair_oil.webp?v=1774597567",
    "ingredients": [
      { "name": "Argan Oil", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/ArganOil.webp?v=1770297123", "content": "Rich in fatty acids, improves hair elasticity and reduces breakage." },
      { "name": "Rosemary Extract", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Rosemary_Oil.png?v=1758868752", "content": "Improves scalp circulation and supports thicker hair growth." }
    ],
    "effect": "Nourish Oil deeply nourishes hair for strength and shine."
  },
  {
    "product": "Her Nourish",
    "variant_id": "47302857621682",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_her_nourish.webp?v=1774597567",
    "ingredients": [
      { "name": "Deodar", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Deodar.webp?v=1770616150", "content": "Helps reduce scalp inflammation and microbial buildup that can weaken hair roots." },
      { "name": "Latakranj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Latakranj.webp?v=1770616191", "content": "Traditionally used to support hair pigmentation and reduce premature greying." }
    ],
    "effect": "Protects hair from hormonal hair fall."
  },
  {
    "product": "Shine Leave in Serum",
    "variant_id": "47301148803250",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "Twice a week" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_shine_serum.webp?v=1774597568",
    "ingredients": [
      { "name": "Dimethicone", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Dimethicone.webp?v=1770616417", "content": "Forms a protective layer to smooth hair and reduce friction-related breakage." }
    ],
    "effect": "Shine Serum enhances hair texture for a vibrant, healthy look."
  },
  {
    "product": "Defence Shampoo 180ml",
    "variant_id": "47301151064242",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "During wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_defence_shampoo_180_ml.webp?v=1774597568",
    "ingredients": [
      { "name": "Vitamin B3", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vitamin_B3.webp?v=1770616654", "content": "Improves scalp blood circulation, supporting healthier hair follicles." },
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping improve hair strength and thickness." }
    ],
    "effect": "Defence Shampoo ensures hair hygiene for a healthy scalp."
  },
  {
    "product": "Defence Shampoo 100ml",
    "variant_id": "47084348309682",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "During wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_defence_shampoo_180_ml.webp?v=1774597568",
    "ingredients": [
      { "name": "Vitamin B3", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Vitamin_B3.webp?v=1770616654", "content": "Improves scalp blood circulation, supporting healthier hair follicles." },
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping improve hair strength and thickness." }
    ],
    "effect": "Defence Shampoo ensures hair hygiene for a healthy scalp."
  },
  {
    "product": "Defence Conditioner",
    "variant_id": "44650256728242",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "During wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_defence_conditioner.webp?v=1774597568",
    "ingredients": [
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping strengthen hair and reduce breakage." },
      { "name": "Rice Protein", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808", "content": "Strengthens hair strands, improves elasticity, and reduces breakage." }
    ],
    "effect": "Defence conditioner improves hair quality by deeply moisturizing the hair strands."
  },
  {
    "product": "Defence Conditioner 50g",
    "variant_id": "45277154377906",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": null, "hair_wash_day": "During wash" },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_defence_conditioner.webp?v=1774597568",
    "ingredients": [
      { "name": "Biotin", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Biotin.webp?v=1770376883", "content": "Supports keratin production, helping strengthen hair and reduce breakage." },
      { "name": "Rice Protein", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Hydrolysed_Rice_protein.webp?v=1770616808", "content": "Strengthens hair strands, improves elasticity, and reduces breakage." }
    ],
    "effect": "Defence conditioner improves hair quality by deeply moisturizing the hair strands."
  },
  {
    "product": "Consti Clear for Improved Bowel Movement",
    "variant_id": "46466005598386",
    "internal": true,
    "external": false,
    "dosage": { "morning": null, "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_consti_clear.webp?v=1774597567",
    "ingredients": [],
    "effect": "Consti clear supports digestion to help reduce hair fall."
  },
  {
    "product": "Minoxidil 2%",
    "variant_id": "47329517568178",
    "internal": false,
    "external": true,
    "dosage": { "morning": "1ml", "night": "1ml", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_minoxidil_topical_solution_2.webp?v=1774597567",
    "ingredients": [
      { "name": "Minoxidil 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305", "content": "Stimulates inactive follicles to support visible hair regrowth in early hair thinning." },
      { "name": "Procapil 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316", "content": "Helps slow hair follicle ageing and supports reduced hair fall." }
    ],
    "effect": "Minoxidil 2% promotes hair regrowth for thicker, fuller hair."
  },
  {
    "product": "Minoxidil 5%",
    "variant_id": "47302891929778",
    "internal": false,
    "external": true,
    "dosage": { "morning": "1ml", "night": "1ml", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_minoxidil_5__finasteride_1.webp?v=1774597567",
    "ingredients": [
      { "name": "Minoxidil 5%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305", "content": "Strongly activates follicles to promote denser, faster hair regrowth." },
      { "name": "Procapil 3%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316", "content": "Helps slow hair follicle ageing and supports reduced hair fall." }
    ],
    "effect": "Minoxidil 5% promotes hair regrowth for thicker, fuller hair."
  },
  {
    "product": "Minoxidil 5% Alcohol Free",
    "variant_id": "46465512898738",
    "internal": false,
    "external": true,
    "dosage": { "morning": "1ml", "night": "1ml", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_minoxidil_5__finasteride_1_alcohol_free.webp?v=1774597568",
    "ingredients": [
      { "name": "Minoxidil 5%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305", "content": "Strongly activates follicles to promote denser, faster hair regrowth." },
      { "name": "Procapil 3%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316", "content": "Helps slow hair follicle ageing and supports reduced hair fall." }
    ],
    "effect": "Minoxidil 5% alcohol free promotes hair regrowth for thicker, fuller hair."
  },
  {
    "product": "Minoxidil 2% Alcohol Free",
    "variant_id": "46465596719282",
    "internal": false,
    "external": true,
    "dosage": { "morning": "1ml", "night": "1ml", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_minoxidil_topical_solution_2.webp?v=1774597567",
    "ingredients": [
      { "name": "Minoxidil 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Minoxidil_2ing.webp?v=1770380305", "content": "Stimulates inactive follicles to support visible hair regrowth in early hair thinning." },
      { "name": "Procapil 2%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Procapil_2.webp?v=1770380316", "content": "Helps slow hair follicle ageing and supports reduced hair fall." }
    ],
    "effect": "Minoxidil 2% alcohol free promotes hair regrowth for thicker, fuller hair."
  },
  {
    "product": "Hair Santulan 01",
    "variant_id": "47302996394162",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_santulan_1.webp?v=1774597568",
    "ingredients": [
      { "name": "Bhringraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930", "content": "Bhringraj prevents hair thinning and keeps the scalp free of dandruff and excess grease." },
      { "name": "Shatavari", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027", "content": "Supports hormonal balance and follicle nourishment, helping reduce female-pattern hair thinning." }
    ],
    "effect": "Hair Santulan is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Santulan 02",
    "variant_id": "47446793879730",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_santulan_2.webp?v=1774597567",
    "ingredients": [
      { "name": "Amalki", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Supports collagen production and strengthens hair follicles at the root." },
      { "name": "Bhringraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930", "content": "Nourishes hair roots and supports longer, stronger hair growth." }
    ],
    "effect": "Hair Santulan is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Santulan 03",
    "variant_id": "47303079166130",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_santulan_3.webp?v=1774597568",
    "ingredients": [
      { "name": "Amalki", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Supports collagen production and strengthens hair follicles at the root." },
      { "name": "Bhringraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930", "content": "Nourishes hair roots and supports longer, stronger hair growth." }
    ],
    "effect": "Hair Santulan is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Active Serum",
    "variant_id": "47300731568306",
    "internal": false,
    "external": true,
    "dosage": { "morning": null, "night": "1ml", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_actives.webp?v=1774597567",
    "ingredients": [
      { "name": "3% Redensyl", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Redensyl.webp?v=1770627288", "content": "Activates hair follicles to support faster, denser hair regrowth." },
      { "name": "Procapil 3%", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_1_Procapil.webp?v=1776421233", "content": "Helps reduce hair fall and supports thicker, stronger hair regrowth." }
    ],
    "effect": "Hair Active Serum prevents hair thinning for fuller, healthier hair."
  },
  {
    "product": "Hair Ras 01",
    "variant_id": "47302757875890",
    "internal": true,
    "external": false,
    "dosage": { "morning": "2 Tablets", "night": "2 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras_1.webp?v=1774597568",
    "ingredients": [
      { "name": "Amalki", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Improves hair strength and supports natural hair growth." },
      { "name": "Bhringraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930", "content": "Nourishes hair roots and supports longer, stronger hair growth." }
    ],
    "effect": "Hair Ras is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Ras 02",
    "variant_id": "47301161091250",
    "internal": true,
    "external": false,
    "dosage": { "morning": "3 Tablets", "night": "3 Tablets", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras_2.webp?v=1774597568",
    "ingredients": [
      { "name": "Bhringraj", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Bhringraj_1.webp?v=1770626930", "content": "Nourishes the scalp and supports stronger, longer hair growth." },
      { "name": "Guduchi", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Property_19.webp?v=1770627488", "content": "Reduces inflammation and supports scalp and hair follicle health." }
    ],
    "effect": "Hair Ras is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Ras 05",
    "variant_id": "46464896630962",
    "internal": true,
    "external": false,
    "dosage": { "morning": "4 TABS", "night": "4 TABS", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras_5.webp?v=1774597567",
    "ingredients": [
      { "name": "Amalki", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Supports collagen production and strengthens hair follicles at the root." },
      { "name": "Iron Bhasma", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Iron_Bhasma.webp?v=1770627628", "content": "Helps correct iron deficiency, supporting healthy hair growth from within." }
    ],
    "effect": "Hair Ras is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Ras 06",
    "variant_id": "47301139169458",
    "internal": true,
    "external": false,
    "dosage": { "morning": "5 TABS", "night": "5 TABS", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras_6.webp?v=1774597567",
    "ingredients": [
      { "name": "Shatavari", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Shatavari.webp?v=1770375027", "content": "Shatavari helps balance internal heat and hormones, which in turn helps promote healthy hair." },
      { "name": "Brahmi", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Brahmi.webp?v=1770375027", "content": "Reduces stress hormones and supports scalp nourishment, helping control stress-related hair fall." }
    ],
    "effect": "Hair Ras is customized to target internal root causes of your hair fall."
  },
  {
    "product": "Hair Ras 09",
    "variant_id": "46464745308338",
    "internal": true,
    "external": false,
    "dosage": { "morning": "6 TABS", "night": "6 TABS", "hair_wash_day": null },
    "product_image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/name_hair_ras_9.webp?v=1774597567",
    "ingredients": [
      { "name": "Ashwagandha", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Ashwagandha.webp?v=1770377173", "content": "Ashwagandha helps reduce stress and encourages blood circulation in the scalp, thereby encouraging hair growth." },
      { "name": "Amalki", "image": "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/amla.webp?v=1770375815", "content": "Boosts collagen synthesis and antioxidant protection, strengthening hair follicles at the root." }
    ],
    "effect": "Hair Ras is customized to target internal root causes of your hair fall."
  }
]
const ALL_PRODUCTS = window.PRODUCT_DATA;